import * as React from "react";

const CompassIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <g clipPath="url(#clip0_2_595)">
      <path
        fill="#000"
        d="m30.628 15.018-3.71-.927a11.48 11.48 0 0 0-10-10l-.93-3.713a.5.5 0 0 0-.97 0l-.927 3.714a11.48 11.48 0 0 0-10 10l-3.713.926a.5.5 0 0 0 0 .97l3.71.928a11.48 11.48 0 0 0 10 10l.93 3.712a.5.5 0 0 0 .97 0l.928-3.71a11.48 11.48 0 0 0 10-10l3.712-.93a.5.5 0 0 0 0-.97m-4.756-1.188-6.956-1.74-1.739-6.952a10.48 10.48 0 0 1 8.691 8.692zM15.503 2.565l2.447 9.785-2.447 2.446-2.446-2.446zM13.83 5.138l-1.74 6.953-6.952 1.739a10.48 10.48 0 0 1 8.692-8.692m-1.48 7.92 2.446 2.445-2.446 2.447-9.785-2.447zm-7.212 4.124 6.953 1.734 1.739 6.952a10.48 10.48 0 0 1-8.692-8.69zm10.365 11.26-2.446-9.785 2.446-2.446 2.447 2.446zm1.674-2.574 1.739-6.952 6.952-1.739a10.48 10.48 0 0 1-8.69 8.691m1.48-7.918-2.446-2.447 2.446-2.446 9.785 2.446z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2_595">
        <path fill="#fff" d="M0 0h32v32H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CompassIcon;
